// chain_dropdown.jsx
"use client";

import React, { useState, useEffect } from "react";
import { getChains } from "../Controller.js";

import '../style.css'
import { Select, Typography } from "antd";
import { CaretDownOutlined } from "@ant-design/icons";

const {Option} = Select;

export default function ChainDropdown({ chain, setChain }) {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getChains();
        setData(result);
        if (!chain && result.length > 0) {
          setChain(result[0].id); // Set default chain
        }
      } catch (err) {
        console.error(err);
      }
    };
    fetchData();
  }, []);

  const handleChange = (value) => {
    setChain(value);
  };

  return (
    <>
      <div className="div-space-between">
        <Typography style={{ fontSize: '21px', fontWeight: 500,  }}>
          Custom Chain Flow Analytics
        </Typography>

        <Select value={chain} onChange={handleChange} style={{ width: 220, height: 36, borderRadius: 8, color: '#6b43b5', }}  suffixIcon={<CaretDownOutlined style={{ color: '#6b43b5' }} />}>
          {data.map((flow, index) => (
            <Option key={index} value={flow.id}>
              {flow.name}
            </Option>
          ))}
        </Select>
      </div>
      <Typography style={{ fontSize: '14px', fontWeight: 400, color: '#848696', margin: '7px 0' }}>
        Chain flows are configured in Django Admin panel. This dashboard provides read-only visualization of configured chains, showing patient progression and drop-off rates at each step. Current timeframe: monthly. Data is updated every 15 minutes and reflects real-time patient interactions across all clinic systems.
      </Typography>

      <div style={{borderRadius:8, backgroundColor: '#f6f5fd', padding: 14 }}>
        <Typography style={{ fontSize: '14px', fontWeight: 400, color: '#6b43b5', }}>
          Complete patient journey 
        </Typography>
      </div>
    </>
  );
}
